export default __webpack_public_path__ + "static/media/KZ.Т.12.Е0718.1a7152e2.svg";